import React, {FC, useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {LoginContext} from "../Contexts/LoginContext";
import {Result, Spin} from "antd";
import {PublicShell} from "../Components/ui/PublicShell";

const EmailConfirmedPage: FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {setLoginState} = useContext(LoginContext);

    useEffect(() => {
        setTimeout(() => {
            setLoginState({
                justConfirmedEmail: true,
            });
            navigate("/Login", {replace: true});
        });
    }, [navigate]);

    return (
        <PublicShell live>
            <Result icon={<Spin/>} title={t("EmailConfirmed_PleaseWait")}/>
        </PublicShell>
    );
}

export default EmailConfirmedPage;
    